/** Nominal map width used to turn an extent into a zoom, in CSS pixels. */
const NOMINAL_MAP_WIDTH_PX = 1200;
const MIN_DERIVED_ZOOM = 3;
const MAX_DERIVED_ZOOM = 18;

/**
 * The zoom level needed to show all of `extent`.
 *
 * MapKit zoom levels follow web mercator. Each level shows half as much
 * longitude as the level below it, and level 0 shows 360 degrees in 256 pixels.
 *
 * The result is approximate, because the real width of the map in pixels is not
 * known here. Callers run this before the map exists, or before opening the
 * page that contains it. An approximate value is enough: the purpose is to show
 * a saved search at the zoom it was saved at, so that the number of listings
 * matches the number on its card.
 */
export function zoomForExtent(extent: { east: number; west: number }): number {
  const longitudeSpan = Math.abs(extent.east - extent.west);
  if (!longitudeSpan) return MAX_DERIVED_ZOOM;
  const zoom = Math.log2(360 / longitudeSpan) + Math.log2(NOMINAL_MAP_WIDTH_PX / 256);
  return Math.min(MAX_DERIVED_ZOOM, Math.max(MIN_DERIVED_ZOOM, Math.floor(zoom)));
}
